const showAdditionalService = false;
const routes = [
  {
    path: '/business',
    component: () => import('@/layouts/WpLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/login',
      },
      {
        path: 'get-started',
        name: 'business-get-started',
        component: () => import('@/pages/Business/BusinessSignUp.vue'),
        meta: {
          rule: 'guest',
          iframeOnly: true,
          wpUrl: process.env.VUE_APP_WP_SIGN_UP_URL_FOR_BUSINESS,
        },
      },
      {
        path: 'reset-password',
        name: 'business-reset-password',
        component: () => import('@/pages/Business/BusinessResetPassword.vue'),
        meta: {
          rule: 'guest',
          iframeOnly: true,
          wpUrl: process.env.VUE_APP_WP_LOGIN_URL_FOR_BUSINESS,
        },
      },
      {
        path: 'login',
        name: 'business-login',
        component: () => import('@/pages/Business/BusinessLogin.vue'),
        meta: {
          rule: 'guest',
          iframeOnly: true,
          wpUrl: process.env.VUE_APP_WP_LOGIN_URL_FOR_BUSINESS,
        },
      },
      {
        path: 'activate',
        name: 'business-activate',
        component: () => import('@/pages/Business/BusinessActivate.vue'),
        meta: {
          rule: 'guest',
          iframeOnly: true,
          wpUrl: process.env.VUE_APP_WP_ACTIVATE_URL_FOR_BUSINESS,
        },
      },
    ],
  },
  {
    path: '/business',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/dashboard',
      },
      {
        path: 'dashboard',
        name: 'business-dashboard',
        component: () => import('@/pages/Business/BusinessDashboard.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'Dashboard',
        },
      },
      {
        path: 'instructions',
        name: 'business-instructions',
        component: () => import('@/pages/Business/BusinessInstructions.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'Instructions',
        },
      },
      {
        path: 'user-profile',
        name: 'business-user-profile',
        component: () => import('@/pages/Basic/UserProfile.vue'),
        meta: {
          rule: 'business',
        },
      },
      {
        path: 'create',
        name: 'business-create',
        component: () => import('@/pages/Business/BusinessCreate.vue'),
        meta: {
          rule: 'business',
        },
      },
      {
        path: 'update',
        name: 'business-update',
        component: () => import('@/pages/Business/BusinessUpdate.vue'),
        meta: {
          rule: 'business',
          pageTitle: ' ',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'My Business Details',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'credit-check',
        name: 'business-credit-check',
        component: () => import('@/pages/Business/BusinessCreditCheck.vue'),
        meta: {
          rule: 'business',
          pageTitle: '',
          hideNav: true,
          redirect: 'leaveWithDialog',
          dark: true,
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'Credit Check',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'credit-check-result',
        name: 'business-credit-check-result',
        component: () =>
          import('@/pages/Business/BusinessCreditCheckResult.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'Business Credit Check',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'Credit Check',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'api-credentials',
        name: 'business-api-credentials',
        component: () => import('@/pages/Business/APICredentials/Index.vue'),
        meta: {
          rule: 'allowOAuthCRUD',
          pageTitle: ' ',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'My API Credentials',
              disabled: true,
            },
          ],
        },
      },
      // =============================================================================
      // Risk Profile Routes
      // =============================================================================
      {
        path: 'risk-profiles/create',
        name: 'business-risk-profile-create',
        component: () =>
          import('@/pages/Business/RiskProfile/RiskProfileCreate.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'Create Risk Profile',
          dark: true,
          hideNav: true,
          redirect: 'leaveWithDialog',
          appBarActions: () => [
            {
              name: 'UPDATE',
              label: 'Save as draft',
            },
          ],
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'Risk Profiles',
              'active-class': '',
              to: () => ({
                name: 'business-risk-profile-list',
              }),
            },
            {
              text: 'Create Risk Profile',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'risk-profiles/:riskProfileOid/update',
        name: 'business-risk-profile-update',
        component: () =>
          import('@/pages/Business/RiskProfile/RiskProfileUpdate.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'Update Risk Profile',
          dark: true,
          hideNav: true,
          redirect: 'leaveWithDialog',
          appBarActions: () => [
            {
              name: 'UPDATE',
              label: 'Save',
            },
            {
              name: 'CREATE',
              label: 'Publish',
            },
          ],
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'Risk Profiles',
              'active-class': '',
              to: () => ({
                name: 'business-risk-profile-list',
              }),
            },
            {
              text: 'Update Risk Profile',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'risk-profiles/list',
        name: 'business-risk-profile-list',
        component: () =>
          import('@/pages/Business/RiskProfile/RiskProfileList.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'Risk Profile List',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'Risk Profiles',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'risk-profiles/:riskProfileOid',
        name: 'business-risk-profile-read',
        component: () =>
          import('@/pages/Business/RiskProfile/RiskProfileRead.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'View Risk Profile',
          dark: true,
          hideNav: true,
          redirect: 'leave',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'Risk Profiles',
              'active-class': '',
              to: () => ({
                name: 'business-risk-profile-list',
              }),
            },
            {
              text: 'View Risk Profile',
              disabled: true,
            },
          ],
        },
      },
      // =============================================================================
      // Booking Routes
      // =============================================================================
      {
        path: 'bookings/create',
        name: 'business-booking-create',
        component: () => import('@/pages/Business/Booking/BookingCreate.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'Create Booking',
          dark: true,
          hideNav: true,
          redirect: 'leaveWithDialog',
          appBarActions: () => [],
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'Booking History',
              'active-class': '',
              to: () => ({
                name: 'business-booking-list',
              }),
            },
            {
              text: 'Create Booking',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'bookings/general-health-check',
        name: 'business-booking-create-ghc',
        component: () =>
          import('@/pages/Business/Booking/BookingCreateGHC.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'Create Booking',
          dark: true,
          hideNav: true,
          redirect: 'leaveWithDialog',
          appBarActions: () => [],
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'Booking History',
              'active-class': '',
              to: () => ({
                name: 'business-booking-list',
              }),
            },
            {
              text: 'Create General Health Check Booking',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'bookings/list',
        name: 'business-booking-list',
        component: () => import('@/pages/Business/Booking/BookingList.vue'),
        meta: {
          rule: 'business',
          pageTitle: ' ',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'Booking History',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'bookings/:bookingOid',
        name: 'business-booking-read',
        component: () => import('@/pages/Business/Booking/BookingRead.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'Booking',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'Booking History',
              'active-class': '',
              to: () => ({
                name: 'business-booking-list',
              }),
            },
            {
              text: 'View Quescreen',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'bookings/:bookingOid/report/:questionnaireAnswerOid',
        name: 'business-booking-candidate-report',
        component: () => import('@/pages/Business/Booking/BookingReport.vue'),
        meta: {
          rule: 'business',
          dark: true,
          hideNav: true,
        },
      },
      // =============================================================================
      // Service Order
      // =============================================================================
      {
        path: 'service-orders/create',
        name: 'business-service-order-create',
        component: () =>
          import('@/pages/Business/ServiceOrder/ServiceOrderCreate.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'Purchase Quescreen',
          dark: true,
          hideNav: true,
          redirect: 'leaveWithDialog',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text:
                'Purchase Quescreen' +
                (showAdditionalService ? ' or Additional Services' : ''),
              'active-class': '',
              to: () => ({
                name: 'business-service-order-list',
              }),
            },
            {
              text: 'Purchase Quescreen',
              disabled: true,
            },
          ],
        },
      },

      {
        path: 'service-orders/list',
        name: 'business-service-order-list',
        component: () =>
          import('@/pages/Business/ServiceOrder/ServiceOrderList.vue'),
        meta: {
          rule: 'business',
          pageTitle: ' ',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text:
                'Purchase Quescreen' +
                (showAdditionalService ? ' or Additional Services' : ''),
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'service-orders/:serviceOrderOid',
        name: 'business-service-order-read',
        component: () =>
          import('@/pages/Business/ServiceOrder/ServiceOrderRead.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'View Order',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text:
                'Purchase Quescreen' +
                (showAdditionalService ? ' or Additional Services' : ''),
              'active-class': '',
              to: () => ({
                name: 'business-service-order-list',
              }),
            },
            {
              text: 'View Order',
              disabled: true,
            },
          ],
        },
      },
      // =============================================================================
      // Service Request
      // =============================================================================
      {
        path: 'service-requests/:serviceRequestOid',
        name: 'business-service-request-read',
        component: () =>
          import('@/pages/Business/ServiceRequest/ServiceRequestRead.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'View Service Request',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'Service Requests',
              'active-class': '',
              to: () => ({
                name: 'business-service-request-list',
              }),
            },
            {
              text: 'View Service Request',
              disabled: true,
            },
          ],
        },
      },
      {
        path: 'service-requests',
        name: 'business-service-request-list',
        component: () =>
          import('@/pages/Business/ServiceRequest/ServiceRequestList.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'Service Request List',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'Service Requests',
              disabled: true,
            },
          ],
        },
      },
      // =============================================================================
      // Booking Candidate Routes
      // =============================================================================
      {
        path: 'booking-candidates',
        name: 'business-booking-candidate-list',
        component: () =>
          import('@/pages/Business/BookingCandidate/BookingCandidateList.vue'),
        meta: {
          rule: 'business',
          pageTitle: 'Quescreen Candidate History',
          breadcrumbs: [
            {
              text: 'Dashboard',
              to: () => ({
                name: 'business-dashboard',
              }),
            },
            {
              text: 'Quescreen Candidate History',
              disabled: true,
            },
          ],
        },
      },
    ],
  },
];

export default routes;
